// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const WithProps = ({children,...props}) => children(props);

export default WithProps;
